export default __webpack_public_path__ + "static/media/marker-blue-red.36190611.png";